import { gql } from "@/__generated__/gql";

export const PROFILE_QUESTIONS_QUERY = gql(`
  query ProfileQuestions($notAnsweredByUserId: ID) {
    profileQuestions(
      filter: FUN_FACTS
      notAnsweredByUserId: $notAnsweredByUserId
      ordering: { field: UPDATED_AT, direction: DESC }
      first: 50
    ) {
      nodes {
        id
        text
      }
    }
  }
`);
